module.exports = __webpack_public_path__ + "img/1487377239.fcdedd34.jpg";